import { createApiSlice } from "@common";
import { CRUD_CONTRACT_CATEGORY } from "@routes";

const apiConfig = [
  {
    name: "addContractCategory",
    method: "post",
    url: CRUD_CONTRACT_CATEGORY,
    stateKey: "message",
  },
  {
    name: "getContractCategory",
    method: "get",
    url: CRUD_CONTRACT_CATEGORY,
    stateKey: "data",
  },
  {
    name: "updateContractCategory",
    method: "put",
    url: CRUD_CONTRACT_CATEGORY,
    stateKey: "message",
  },
  {
    name: "deleteContractCategory",
    method: "delete",
    url: CRUD_CONTRACT_CATEGORY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"contractCategory",
 apiConfig, 
 customReducers);
const contractCategorySlice = slice;

export default contractCategorySlice.reducer;

export const {
  addContractCategory,
  getContractCategory,
  updateContractCategory,
  deleteContractCategory,
} = thunks;

export const { rowSelect } = actions;
